/* eslint-disable react/style-prop-object, react/no-unknown-property */
import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function PlaylistIcon({ height = 60, width = 60, ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      styl
    >
      <path d="M17.9199 15.0596C18.3403 15.102 18.6688 15.4571 18.6689 15.8887C18.6689 16.3203 18.3404 16.6753 17.9199 16.7178L17.8359 16.7227H6.1709C5.71071 16.7226 5.33789 16.3489 5.33789 15.8887C5.33801 15.4286 5.71078 15.0557 6.1709 15.0557H17.8359L17.9199 15.0596Z" fill="white" />
      <path d="M17.8457 11.167C18.3057 11.1673 18.6787 11.5399 18.6787 12C18.6787 12.4601 18.3057 12.8327 17.8457 12.833H12C11.5398 12.833 11.167 12.4602 11.167 12C11.167 11.5398 11.5398 11.167 12 11.167H17.8457Z" fill="white" />
      <path d="M5.33301 7.9043C5.33354 7.63415 5.64692 7.46704 5.89355 7.60547L9.96094 9.8916C10.207 10.0299 10.2007 10.3677 9.94922 10.4971L5.88086 12.5869C5.63427 12.7132 5.33336 12.5455 5.33301 12.2812V7.9043Z" fill="white" />
      <path d="M17.8389 7.27734C18.299 7.27749 18.6719 7.65118 18.6719 8.11133C18.6718 8.57138 18.2989 8.94419 17.8389 8.94434H12C11.5398 8.94434 11.1671 8.57147 11.167 8.11133C11.167 7.65109 11.5398 7.27734 12 7.27734H17.8389Z" fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M21.0029 2.00586C21.563 2.06296 22 2.53618 22 3.11133V20.8887L21.9941 21.0029C21.9409 21.5255 21.5255 21.9409 21.0029 21.9941L20.8887 22H3.11133C2.53618 22 2.06296 21.563 2.00586 21.0029L2 20.8887V3.11133C2 2.49768 2.49768 2 3.11133 2H20.8887L21.0029 2.00586ZM3.66699 20.333H20.333V3.66699H3.66699V20.333Z" fill="white" />

    </SVGWrapper>
  );
}

export default PlaylistIcon;
